









import Vue, { PropType } from "vue";
import TextModel from "@/dex-shared/models/TextModel";
import VueMarkdown from "vue-markdown";
import DOMPurify from "dompurify";

export default Vue.extend({
  components: {
    VueMarkdown
  },

  props: {
    text: {
      type: Object as PropType<TextModel>,
      required: true
    },
    trustedContent: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    sanitize(text) {
      // const replacedText = text.replace(/src="http:/g, 'src="https:');
      return this.trustedContent ? text : DOMPurify.sanitize(text);
    }
  }
});
